
import { HttpUserList } from '../../../service/notice';
import TableList from "../../../components/templates/tablelist";

export default {
    mixins: [TableList],
    data() {
        return {
            isMixin: true,
            Searchs: {
                show: true,
                style: "border:none;",
                labelWidth: "auto",
                align: "left"
            },
        };
    },
    methods: {
        ajaxRequest: HttpUserList,
        handleOperates(data) {
            this.$emit('on-data', data)
        },
    },
    computed: {
        SearchsData() {
            return [
                {
                    label: "名称",
                    key: 'CN_name',
                    tag: 'vInput',
                    show: true,
                },
                {
                    label: "邮箱",
                    tag: 'vInput',
                    key: 'EQ_email',
                    show: true,
                },
            ]
        },
        columns() {
            return [
                {
                    title: 'ID',
                    key: 'id',
                },
                {
                    title: '名称',
                    key: 'name',
                }, {
                    title: '邮箱',
                    key: 'email',
                }, {
                    title: "操作",
                    width: 120,
                    align: "center",
                    render: (h, { row }) => {
                        return <vButton theme="primary" nativeOnClick={this.handleOperates.bind(this, row)}>选择</vButton>
                    }
                }];
        },
    },
};




